<kpd-confirm-dialog key="confirm"></kpd-confirm-dialog>
<app-permission-sets-import-wizard></app-permission-sets-import-wizard>

<kpd-data-view
  [tableName]="'permissionsets'"
  [dataProvider]="entityFacade"
  [columnsConfig]="columnsConfig"
  [searchConfig]="searchConfig"
  [urlFunction]="urlFunction"
  (linkClicked)="onLinkClicked($event)"
>
  <ng-template kpdTemplate="toolBar" let-loading="loading">
    <kpd-action-bar>
      <div class="actionbar--hide">
        <kpd-action icon="import" (action)="onImport()" [title]="'Import templates' | translate"></kpd-action>
        <kpd-action-create
          *kpdPermission="Permissions.PermissionsetCreate"
          (action)="onAdd()"
          [title]="'Add permission set' | translate"
        ></kpd-action-create>
        <span *ngIf="selectedItemIds.length > 0" class="flex-row">
          <kpd-action-consult-overview (action)="onView(selectedItemIds[0])"></kpd-action-consult-overview>
          <kpd-action-edit-toggle
            *kpdPermission="Permissions.PermissionsetUpdate"
            (action)="onEdit(selectedItemIds[0])"
            [readMode]="false"
          ></kpd-action-edit-toggle>
          <kpd-action-delete *kpdPermission="Permissions.PermissionsetDelete" (action)="onDelete()"></kpd-action-delete>
        </span>
        <kpd-action-separator></kpd-action-separator>
      </div>
      <kpd-action
        [icon]="viewType === ViewTypes.Table ? 'view-cards' : 'view-columns'"
        kpdHotkey="mod+m"
        [title]="'Change mode' | translate"
        (action)="onToggleViewType()"
      ></kpd-action>

      <kpd-action
        icon="refresh"
        kpdHotkey="mod+r"
        [title]="'Refresh' | translate"
        [disable]="loading"
        (action)="onRefresh()"
      ></kpd-action>
      <div class="actionbar--hide">
        <kpd-action icon="bars" (action)="onToggleSidepanel()" [title]="'Open sidepanel' | translate"></kpd-action>
      </div>
    </kpd-action-bar>
  </ng-template>

  <ng-template kpdTemplate="cardItem" let-item>
    <div class="card">
      <label class="title" translate>Name</label>
      <label class="value">{{ item.name }}</label>
      <label class="title" translate>Application</label>
      <label class="value">{{ item.application }}</label>
      <label class="title" translate>Description</label>
      <label class="value">{{ item.description | kpdDefault }}</label>
    </div>
  </ng-template>

  <ng-template kpdTemplate="tableExtra" let-column let-item="item" let-index="index">
    <label *ngIf="column.type === 'KPD' && item[column.field] === true">
      <img
        src="assets/logos/kpd-logo_36x16.svg"
        alt="KPD"
        [attr.title]="'This is a predefined set by KPD' | translate"
        class="kpd-logo--blue-sm"
      />
    </label>
    <label *ngIf="column.type === 'type'" class="tags">
      <span class="state-tag" [ngClass]="{ 'state-tag--disabled': !hasAssign(item) }">{{ 'Assign' | translate }}</span>
      <span class="state-tag" [ngClass]="{ 'state-tag--disabled': !hasUse(item) }">{{ 'Use' | translate }}</span>
    </label>
  </ng-template>
</kpd-data-view>
